import { Bridge } from 'dolphin-native-bridge'
const globalEvent = weex.requireModule('globalEvent')

// __diabloMode__ 是否适配暗黑模式全局变量 - true/false

const DiabloMixin = {
  data() {
    return {
      // DOL_IS_SUPPORT_DIABLO: __diabloMode__, // 是否适配暗黑模式-true/false
      // IS_DIABLO: typeof __diabloMode__ !== 'undefined' && __diabloMode__ && Bridge.getDiablomodeSync() == '1' // 当前是否暗黑模式-true/false
    }
  },

  computed: {
    _theme() {
      return this.$theme ? (this.$theme.getRootTheme && this.$theme.getRootTheme()) || this.$theme.getTheme() : ''
    },
    _isColmo() {
      if (!this.$theme) return false
      return this._theme === 'colmo'
    },
    _isDiablo() {
      // let _theme = this.$theme ? (this.$theme.getRootTheme && this.$theme.getRootTheme()) || this.$theme.getTheme() : ''
      // let isColmo = _theme && _theme === 'colmo'
      // if (isColmo) return false // colmo不支持黑色模式

      // return this.IS_DIABLO
      if (!this.$theme) return false
      return this._theme === 'diablo'
    }
  },
  created() {    
    if (typeof __diabloMode__ !== 'undefined' && __diabloMode__) {
      // 处理安卓切后台不会收到推送问题，宏任务避免setTheme报错
      setTimeout(() => {
        if (!this._isColmo && this._isDiablo && Bridge.getDiablomodeSync() != '1') this.$theme.setTheme('')
        if (!this._isColmo && !this._isDiablo && Bridge.getDiablomodeSync() == '1') this.$theme.setTheme('diablo')
      }, 0)
      
      // 监听暗黑模式变化
      // globalEvent.addEventListener('receiveMessageFromApp', (data) => {
      //   if (data.messageType == 'diablomodeChange'){
      //     // if (data.messageBody.diabloMode != undefined) this.IS_DIABLO = data.messageBody.diabloMode == '1'
      //     console.log('diablomodeChange-----' + data.messageBody.diabloMode);
      //     data.messageBody.diabloMode != undefined && data.messageBody.diabloMode == '1' ? this.$theme.setTheme('diablo') : this.$theme.setTheme('')
      //   }
      // })
    }
  },
  methods: {
    // 切换暗黑模式
    // _toggleColor(obj) {
    //   return this._isDiablo ? obj['d'] : obj['l']
    // },
    // 新增类名
    // _toggleDiabloClass(origin) {
    //   return this._isDiablo ? origin + '_diablo' : origin
    // }
  }
}

export default DiabloMixin



// WEBPACK FOOTER //
// ./mixins/diablo.js